module.exports = __webpack_public_path__ + "static/media/PowerButton.791f0504.svg";